<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="8">
        <h1 v-text="page.title"/>
        <h3 class="pb-3" v-text="page.subtitel"/>
        <dynamic-text :html="page.tekst"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  async asyncData({$axios, error}) {
    try {
      const {data} = await $axios.get('/page/algemene-voorwaarden');

      return {
        page: data.data,
      };
    } catch (e) {
      error({statusCode: 404, message: e.message});
    }
  },
  data: () => ({
    page: {},
  }),
};
</script>
